import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { Button } from 'primeng/button';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface ButtonFieldProps extends FormlyFieldProps {
  severity?: typeof Button.prototype.severity;
  variant?: typeof Button.prototype.variant;
  size?: typeof Button.prototype.size;
  icon?: string;
  iconPos?: typeof Button.prototype.iconPos;
  onClick: any;
  link?: boolean;
  styleClass?: string;
  raised?: boolean;
  glass?: boolean;
  insetShadow?: boolean;
}

@Component({
  selector: 'text-field',
  standalone: true,
  imports: [...FORM_IMPORTS, Button],
  template: `
    <p-button
      styleClass="{{
        props.styleClass ? props.styleClass : 'w-full'
      }} justify-start"
      [severity]="props.severity ?? 'primary'"
      [variant]="props.variant"
      [size]="props.size"
      [attr.raised]="props.raised ? '' : null"
      [attr.glass]="props.glass ? '' : null"
      [attr.inset-shadow]="props.insetShadow ? '' : null"
      [disabled]="props.disabled ?? false"
      (onClick)="props.onClick(this)"
      [link]="props.link ?? false"
    >
      <div class="flex gap-5 items-center">
        @if (props.icon && (props.iconPos ?? 'left') == 'left') {
          <div [class]="props.icon"></div>
        }
        <div [innerHTML]="props.label"></div>

        @if (props.icon && props.iconPos == 'right') {
          <div [class]="props.icon"></div>
        }
      </div>
    </p-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonFieldType extends FieldType<
  FieldTypeConfig<ButtonFieldProps>
> {}
